import { Panel, Text } from "@ui5/webcomponents-react";
import { spacing } from "@ui5/webcomponents-react-base";
import { useTheme } from '../utils/ThemeContext';

const Rules = () => {
  const { theme } = useTheme();
  // eslint-disable-next-line react/style-prop-object
  let intro = (<div>
  <Panel collapsed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"League Rules"}>
    <Text style={spacing.sapUiContentPadding}>
      <p>In addition to the standard rules, the additional league rules are as follows:</p>
      <ul>
        <li><span>No Mulligans during league play.</span></li>
        <li><span>WTGL plays winter rules on the fairway only!  What this means is, where the fairway is cut, not the rough, you may roll your  ball over if it is in a bare patch or divot.</span></li>
        <li><span>Out of Bounds is played as a hazard. You are permitted to take a drop where the ball last crossed the margin of the golf course.</span></li>
        <li><span>You may rake a bunker if the ball comes to rest  in a foot print, or dog print or goose print etc.  Also if in a blast crater from a previous shot.  Please rake, then recreate your lie as it was.</span></li>
        <li><span>On #1 Village, if you hit your ball into the  water off the tee, you must re-tee or play it from the point of entry into the  hazard. YOU MUST NOT walk down the side of the river and play it where you saw  it splash! Hazards are point of ENTRY drops, not where it ended up.</span></li>
        <li><span>In a effort to speed up play on The Village, #5  will have a drop area if you go into the water or the waste area before the water LEFT of the Bridge. The drop  area will be left of the cart path once you have crossed the bridge. If your  second shot went in to the water, the drop would be your third shot, then your  approach into the green would be your 4th shot.  If the ball goes into the water RIGHT of the bridge then drop the ball at the point of entry.</span></li>
        <li><span>Also in order to speed up play, IF YOU LOSE A BALL - e.g. in the woods or you thought it was in the rough, etc. but can't seem to find it - drop a ball in the area that your playing partners believe your ball was lost and add a 1-stroke penalty and continue play</span></li>
        <li><span>GIMME RULE.  Gimmes are allowed for putts that are within the distance between the bottom of your putter and the bottom of your putter grip (i.e. the metal part of your putter).  Belly putters excluded.</span></li>
</ul>
    </Text>
  </Panel>
  <Panel collapsed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Pace of Play"}>
    <Text style={spacing.sapUiContentPadding}>
      <p>Nobody likes slow play. It should not take more  than 2hrs to play 9 holes at Conestoga.</p>
      <ul>
          <li><span>Keep up to the group in front of you. If the group ahead of you is a complete hole ahead of you, or if you can no longer see the group ahead of you, you need to speed up.</span></li>
          <li><span>Be ready to hit when it is your turn. Get to your ball and prepare to shoot while others in your group are at their ball about to hit.  Don't wait to go to your ball until after another member has shot unless it affects their play.</span></li>
          <li><span>Consider avoiding 'honours' on the tee block and using the 'farthest player away' rule in the fairways and on the green if you notice you can no longer see the group ahead of you.  'Fire when ready!'</span></li>
          <li><span>Place your equipment at the exit points of the  green.</span></li>
          <li><span>WTGL has a double par rule per hole. Pick up when you reach it if people are behind you.</span></li>
    </ul>
    </Text>
  </Panel>
  <Panel collapsed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Point System"}>
    <Text style={spacing.sapUiContentPadding}>
      <p>Points are awarded based on what your <strong><u>net score</u></strong> is that night. Net score is your gross score (whatever you shoot) minus your league handicap.  Eg. You shoot 45 for nine holes. Your league handicap is 10. Your net score is  45 &#45; 10 = 35</p>
      <p>Points are accumulated throughout the season and members are ranked on the leaderboard based on total number of points earned.</p>

<table border="0" cellSpacing="0" cellPadding="0" width="261">
	<tbody>
		<tr>
        	<td width="261" nowrap="nowrap" valign="bottom">
        	<span>Points are awarded as follows:</span>
				
			</td>
        </tr>
	</tbody>
</table>
<div align="center"> 
	<table border="0" cellSpacing="0" cellPadding="0" width="351">
		<tbody>
			<tr>
				<td width="351" nowrap="nowrap" valign="top"><table border="0" cellSpacing="0" cellPadding="0" width="341">
		            <tbody>
		            	<tr>
							<td width="128" align="center" valign="bottom" nowrap="nowrap"><p align="center" ><strong>Minimum</strong></p></td>
							<td width="117" align="center" valign="bottom" nowrap="nowrap"><p align="center" ><strong>Maximum</strong></p></td>
							<td width="96" align="center" valign="bottom" nowrap="nowrap"><p align="center" ><strong>Points</strong></p></td>
						</tr>
						<tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">1</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">28</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">15</td>
              </tr>
            <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">29</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">29</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">14</td>
              </tr>
            <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">30</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">30</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">13</td>
              </tr>
            <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">31</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">31</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">12</td>
              </tr>
            <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">32</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">32</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">11</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">33</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">33</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">10</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">34</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">34</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">9</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">35</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">35</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">8</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">36</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">36</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">7</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">37</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">37</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">6</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">38</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">38</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">5</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">39</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">39</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">4</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">40</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">40</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">3</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">41</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">41</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">2</td>
              </tr>
			  <tr>
              <td width="128" align="center" valign="bottom" nowrap="nowrap">42</td>
              <td width="117" align="center" valign="bottom" nowrap="nowrap">99</td>
              <td width="96" align="center" valign="bottom" nowrap="nowrap">1</td>
              </tr>
            </tbody></table></td>
          </tr>
        </tbody>
	</table>
  </div>
    </Text>
  </Panel>
  <Panel collapsed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"$2 Skins"}>
    <Text style={spacing.sapUiContentPadding}>
      <p>Each week, a $2 portion of your weekly league fee goes towards our $2 Skins event.  
        A Skin is won on a particular hole if one single person in the league scores the lowest 'Net' score on that hole.
          The Net score is calculated based on your league handicap on the day that you played.  
          On the scorecard, each hole is designated a 'Handicap' of 1 through 9.  For example, on the Village course hole number 2 (par 3) has a handicap of '6'.  
          If your handicap is 6 or higher the score you made on that hole would be reduced by 1 or more.  Let's explore a few examples:</p>
          <ul>
            <li>If you have a handicap of under 6 and you scored a '2' on this hole your Net score would be 2</li>
            <li>If your handicap is between 6 and 15 and you scored a '2' on this hole your Net score would be 1</li>
            <li>If your handicap is 15 or higher and you scored a '2' on this hole your Net score would be 0</li>
          </ul>
        <p>Over 9 holes:</p>
        <ul>
          <li>If you have a handicap of less than 9 your Net score will be one less than what you scored on each handicap hole number less than and equal to your handicap Example: if your handicap is 6 your Net score on holes with handicap 1-6 will be one less than what you scored, but your score will not be reduced on handicap holes 7 through 9.</li>
          <li>If you have a handicap of 9 your Net score will be one less than what you scored on every hole</li>
          <li>If you have a handicap higher than 9 then you will get multiple shots reduced on certain holes.  Example:  if your handicap is 12 your net will be 1 less on each of the nine holes.  Additionally, handicap holes 1 through 3 will be reduced by another stroke to account for the additional value your handicap is over 9.</li>
        </ul>
        <p>Skins are awarded for each hole where there is one outright Net score winner.  
          The pot is split amongst all outright winners.  For example:  If there are three holes with an outright winner the pot is split three ways.  
          If there is only one hole with an outright winner the full amount is awarded.  If there is no outright winner on any hole then the pot 
          carries over into the following week.  Only those who played the week there was no outright winner will be eligible for that portion of that pot
           the following week.  For example, if $140 is carried over and in addition the following week there is an additional $100 pot.  
           The total pot is $240.  If you win a skin and had played the previous week, you would be entitled to a portion of the $100 for the current week 
           plus a portion of the $140 from the previous week.  If you did not play the previous week and won a skin you would only be entitled to the $100 pot from the current week.</p>
        <p>For all Par 3 holes, only up to 1 stroke maximum from your handicap will be applied when calculating winners for $2 skins.  
          All other holes the full handicap is applied.  In addition, if there are any hole-in-ones on a par 3 during the league round, that
           person wins the skin outright for that hole.  It's happened in the past where an ace has occurred only to be tied by a birdie due to handicap calculations.  
           Even though it's rare, we want to avoid this moving forward.</p>
    </Text>
  </Panel>
  <Panel collapsed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Calculating Handicaps"}>
    <Text style={spacing.sapUiContentPadding}>
      <p>Your handicap number represents your handicap over nine holes.  For example, if your handicap is 5 then 5 strokes
         are removed from your gross score to represent your net score over the league 9 holes.</p>
      <p>Your handicap for the week is calculated by taking your best 4 of your last 6 weeks gross score to par.  For example let's
         say your last 6 weeks score to par were +10, +11, +7, +8, +5 and +15. Your handicap would be calculated by dropping the highest two scores 
         to par (11 and 15) and then averaging the remaining four:  (10+7+8+5)/4=7.5 rounded up to 8.  Your current handicap for the next round would be 8</p>
      <p>If you haven't yet played 6 weeks, the handicap is calculated by 'padding' the missing weeks with your season starting handicap.  For example, 
        assume your starting handicap is 10 and you've played the first 4 weeks with scores to par of 9,8,13 and 14.  Your best 4 of your last 6 would 
        be calculated by dropping the highest two scores to par (13 and 14) and then adding the two other scores to par this season along with two 'padded' 
        weeks using your starting handicap:  (9 + 8 + 10 + 10)/4 = 9.25 rounded down to 9. Your current handicap for the next round would be 9</p>
    </Text>
  </Panel>
  <Panel collapsed stickyHeader style={{backgroundColor: theme.panelBg}} headerText={"Retrogresssion"}>
    <Text style={spacing.sapUiContentPadding}>
      <p>When there are ties for the low net or gross score for the week you will notice a term "retrogression" appearing in the weekly summary.  
        Retrogression is a method of tie-breaking when two or more finishers complete their rounds with the same score. </p>
      <p>Example:  If Dave and Mike are tied for lowest score after 9 holes, retrogression examines their scores after 8 holes to see if either 
        player had a lead with respect to the other. If Mike had the lead over Dave after 8 holes, he wins low score outright. If both players 
        were tied after 8 holes, then regression looks at their scores after 7 holes, etc.  Consider the following:</p>
        <table className="rulesRetrogression">
          <tr><th><b>Hole:</b></th><th><b>1</b></th><th><b>2</b></th><th><b>3</b></th><th><b>4</b></th><th><b>5</b></th><th><b>6</b></th><th><b>7</b></th><th><b>8</b></th><th><b>9</b></th><th>Total</th></tr>
          <tr><td><b>Mike</b></td><td><b>4</b></td><td><b>5</b></td><td><b>3</b></td><td><b>5</b></td><td><b>3</b></td><td><b>4</b></td><td><b>5</b></td><td><b>4</b></td><td><b>5</b></td><td><b>38</b></td></tr>
          <tr><td><b>Dave</b></td><td><b>5</b></td><td><b>4</b></td><td><b>3</b></td><td><b>4</b></td><td><b>4</b></td><td><b>5</b></td><td><b>5</b></td><td><b>4</b></td><td><b>4</b></td><td><b>38</b></td></tr>
        </table>
      <p>Using retrogression to break the tie, we need to review who had the lead after 8 holes.  After 8 holes, Mike had a total of 33 strokes.  
      Dave had a total of 34.  Therefore, by use of retrogression, Mike wins the round and takes low score.  If there are more than two people tied for low score 
      after 9 holes, the process is similar.  If there are three players tied for example,  examine all three scores after 8 holes.  If two of the three players 
      were tied for lowest score after 8 holes, then examine the 7th hole to determine who was leading between those two players.  The third player is eliminated 
      since that person had a higher score after 8 holes.</p>
      <p>When using retrogression to determine the winner for low net score, the handicaps for each hole are first applied and then retrogression is used over the net scores.</p>
    </Text>
  </Panel>
  </div>);

  return intro;

  };
  
  export default Rules;